import { eTipoPermissao } from '@/enums/ePermissoes';

const permissions = [eTipoPermissao.HISTORICOFUNCIONALNOVO_MENU_1400200199];

export default [
  {
    description: 'Histórico Funcional',
    path: '/pessoal/peshistoricofuncional',
    name: 'peshistoricofuncional',
    component: () => import('@/views/pessoal/peshistoricofuncional/Index.vue'),
    meta: {
      permissions,
    },
    goesToMenu: true,
  },
];
